<script>
  import BaseImage from "@/components/partials/BaseImage.vue";
  import mixin from "../mixin";

  export default {
    components: {
      BaseImage,
    },

    mixins: [mixin],

    data() {
      return {
        status: "",
      };
    },

    computed: {
      partner() {
        return this.notification.content.partner;
      },
      campaign() {
        return this.notification.content.campaign;
      },
      couponRequest() {
        return this.notification.content.couponRequest;
      },
      isCurrentRouteNotifications() {
        return (
          this.$route.name === "coupon-requests"
          || this.$route.name === "all-notifications"
        );
      },
      userPersona() {
        return this.$store.getters["User/userPersona"];
      },
    },

    mounted() {
      this.status = this.notification.status;
    },

    methods: {
      actionHandler(action) {
        this[action.toLowerCase()]();
      },
      allocate() {
        this.setNotificationAsRead();
        this.actionTaken(this.notification.id).then(() => {
          this.status = "action-taken";
          this.$router.push({
            name: "coupons-request-allocation",
            params: {
              id: this.campaign.id,
              requestId: this.notification.content.couponRequest.id,
              requestInfo: this.notification,
            },
          });
          this.$emit("on-popup-state-update", "opened");
        });
      },
    },
  };
</script>
<template>
  <div
    :class="[
      isCurrentRouteNotifications &&
        'd-flex justify-content-between align-items-center',
    ]"
    class="w-100"
    @click="allocate"
  >
    <div class="d-flex justify-content-start align-items-center">
      <div class="img-container m-r-12">
        <BaseImage
          :name="`notification-img-${notification.id}`"
          :src="campaign.logo"
          class="radius-full cursor-pointer fitted-img"
          height="40"
          width="40"
        />
      </div>
      <div class="">
        <p
          :class="{ 'cursor-pointer': canViewCampaigns }"
          class="p-base-medium text-neutral-400 m-b-9"
        >
          <span class="text-neutral-900 m-r-3">{{ partner.name }}</span>
          <span class="m-r-3">{{
            $t(`notifications.${notification.type}.${"has-requested"}`)
          }}</span>
          <span class="text-neutral-900 m-r-3">{{ couponRequest.count }}</span>
          <span class="m-r-3">{{
            $t(`notifications.${notification.type}.${"coupons-for"}`)
          }}</span>
          <span class="text-neutral-900 m-r-3">{{ campaign.name }}</span>
          <span>{{
            $t(`notifications.${notification.type}.${"campaign"}`)
          }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<style lang="sass" scoped></style>
